import { render } from "./ForeignTradeByProductsTable.vue?vue&type=template&id=0a9f7afa&scoped=true&ts=true"
import script from "./ForeignTradeByProductsTable.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByProductsTable.vue?vue&type=script&lang=ts"

import "./ForeignTradeByProductsTable.vue?vue&type=style&index=0&id=0a9f7afa&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9f7afa"]])

export default __exports__